'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Tooltip, _React$PureComponent);

    function Tooltip() {
        (0, _classCallCheck3.default)(this, Tooltip);
        return (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).apply(this, arguments));
    }

    (0, _createClass3.default)(Tooltip, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                text = _props.text,
                _props$placement = _props.placement,
                placement = _props$placement === undefined ? 'top' : _props$placement;

            return _react2.default.createElement('span', { className: 'icon--help', 'data-toggle': 'tooltip', 'data-html': 'true', 'data-placement': placement, 'data-original-title': text, 'data-delay': '{ "show": 0, "hide": 1000 }' });
        }
    }]);
    return Tooltip;
}(_react2.default.PureComponent), _class.propTypes = {
    text: _propTypes2.default.string,
    placement: _propTypes2.default.string
}, _temp);
exports.default = Tooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/Tooltip.js
// module id = 749
// module chunks = 0